import React, { useEffect } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  FormControlLabel,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import styels from "../../styles/components/qcsubmittedvideosduplicatesfilter.module.scss";
import modalstyle from "../../styles/layout/modal/qcsubmittedvideosduplicatesfiltermodal.module.scss";
import { emptyHandle, getDateApiFormat } from "../../lib/functions/utils.lib";
import useCalenderFilter from "../../hooks/useCalenderFilter";

const dialogContainer = {
  [`.MuiDialog-container`]: {
    alignItems: "flex-start",

    [`.MuiDialog-paper`]: {
      marginTop: "72px",
      boxShadow: "none",
      borderRadius: "10px !important",
      [`.MuiDialogContent-root`]: {
        padding: "0 11px",
      },
    },
  },
};

import {
  setFrom,
  setTo,
} from "../../redux-toolkit/slices/qc/qc.submitted.duplicate.slice";
import dayjs from "dayjs";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import CalenderDate from "../../pages/Calender";

export default function QcSubmittedVideosDuplicatesFilter({
  leftItems,
  handleTriggreFetch,
  datas,
}) {
  const calenderContainerId = "calender-input-filter-row";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    resetCalender,
    confirmedCalenderValue,
    calenderValue,
    confirmCalenderTwo,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderContainerId,
  });

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (calenderValue) {
      if (calenderValue[0]) {
        dispatch(setFrom(getDateApiFormat(calenderValue[0]["$d"])));
      }
      if (calenderValue[1]) {
        dispatch(setTo(getDateApiFormat(calenderValue[1]["$d"])));
      }
      handleTriggreFetch();
    }
  }, [calenderValue]);
  return (
    <>
      <Box className={styels.editorFilterWrapper}>
        {true ? (
          <Box className={styels.table_left2}>
            {leftItems}
            <Box className="commonSearchBar_modal">
              <p>
                Showing videos for{" "}
                {calenderFilter ? (
                  <>
                    <Box
                      className={`dayList ${
                        openedDateRangeFilter ? "date-black" : "date-blue"
                      }`}
                    >
                      <Button
                        aria-haspopup="true"
                        onClick={handleOpenDateRangeFilter}
                      >
                        {calenderFilter?.name}
                      </Button>
                      <Menu
                        anchorEl={dateRangeFilterAnchor}
                        open={openedDateRangeFilter}
                        onClose={handleCloseDateRangeFilter}
                        className="dateList"
                      >
                        {DateFilterRangeList.map((filter) => {
                          if (filter != calenderFilter) {
                            return (
                              <MenuItem
                                onClick={changeCalenderFilter(filter)}
                                key={filter.name}
                                selected={filter === calenderFilter}
                              >
                                {filter.name}
                              </MenuItem>
                            );
                          }
                        })}
                      </Menu>
                    </Box>
                    <span className="dateList">
                      ({calenderFilterShowValue})
                    </span>
                  </>
                ) : (
                  <>
                    the period from{" "}
                    {confirmedCalenderValue?.[0] ? (
                      <span className="dayList">
                        {dayjs(confirmedCalenderValue?.[0]).format("LL")}
                      </span>
                    ) : null}{" "}
                    to{" "}
                    {calenderValue?.[1] ? (
                      <span className="dayList">
                        {dayjs(confirmedCalenderValue?.[1]).format("LL")}
                      </span>
                    ) : null}
                  </>
                )}
              </p>
              {calenderFilter?.name !== "All time" ? (
                <span className="reset_picker" onClick={resetCalender}>
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 11 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z"
                      stroke="currentColor"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M4.22705 6.7832L6.77263 4.23762"
                      stroke="currentColor"
                      strokeWidth="0.8"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M6.77263 6.76238L4.22705 4.2168"
                      stroke="currentColor"
                      strokeWidth="0.8"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  reset
                </span>
              ) : null}
            </Box>
          </Box>
        ) : (
          <p className={styels.moreFilter}>
            Showing videos for one or more selected filters.
          </p>
        )}

        <Box className={styels.editorFilterButtonGroup}>
          {/* <Button className={styels.calenderBtn} onClick={handleOpen}><FilterIcon /> </Button> */}
          <Button className={`${styels.calenderBtn} ${styels.calenderVerified}`}>
            <CalenderDate confirmCalender={confirmCalenderTwo} />
          </Button>
          <Button className={styels.allVideo}>
            All videos: <span>{emptyHandle(datas?.total)}</span>
          </Button>
        </Box>
      </Box>
    </>
  );
}
